import { Divider, Group, Select, Stack, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { CreateUserData } from '../context/UsersContext';
import { USER_ROLES } from '../types';
import { roleAsDisplayName } from 'src/admin/users/utils';

export type CreateUserFormValues = Omit<CreateUserData, 'userStatus'>;

interface Props<T extends CreateUserFormValues> {
  form: UseFormReturnType<T>;
}

export default function CreateUserForm<T extends CreateUserFormValues>({ form }: Props<T>) {
  return (
    <>
      <Group grow align="flex-start">
        <TextInput label="First name" placeholder="Jane" {...form.getInputProps('firstName')} />
        <TextInput label="Last name" placeholder="Doe" {...form.getInputProps('lastName')} />
      </Group>

      <TextInput
        label="Email"
        placeholder="Client email address"
        {...form.getInputProps('emailAddress')}
      />

      <Divider my="xs" color="gray.4" />

      <Stack>
        <Select
          label="Permissions role"
          placeholder="Select permissions"
          data={USER_ROLES.map(role => ({ label: roleAsDisplayName(role), value: role }))}
          {...form.getInputProps('userRole')}
        />
      </Stack>
    </>
  );
}
